import { postData, getData, putData, deleteData } from "../plugins/ApiCalls"

export function create(data) {
  return postData('forms', data, { emulateJSON: true })
}

export function getByUser(page = 1) {
  return getData('forms')
}

export function getFormByUser(formId) {
  return getData('forms/' + formId)
}

export function getForm(id) {
  return getData('forms/' + id)
}

export function updateForm(id, data) {
  return putData('forms/' + id, data, { emulateJSON: true })
}

export function getForms(data) {
  let params = new URLSearchParams()

  if (data && data.page) {
    params.append('page', data.page)
  }

  if (data && data.search) {
    params.append('q', encodeURIComponent(JSON.stringify(data.search)))
  }

  return getData('forms?' + params.toString())
}

export function getFormByKey(key, variantId, visitorId) {
  if (variantId) {
    return postData(
      'forms/' + key + '/variants/' + variantId + '/preview',
      { 'leadgen_visitor_id': visitorId },
      { emulateJSON: true }
    )
  } else {
    return postData(
      'forms/key/' + key,
      { 'leadgen_visitor_id': visitorId },
      { emulateJSON: true }
    )
  }
}

export function formsCount() {
  return getData('forms/count')
}

export function getSetting(id) {
  return getData('forms/' + id + '/setting')
}

export function saveSetting(id, data) {
  return putData('forms/' + id + '/setting', data, { emulateJSON: true })
}

export function getOverview(id) {
  return getData('forms/' + id + '/overview')
}

export function duplicate(id, data = {}) {
  if (data.ids && data.ids.length > 1) {
    return postData('forms/' + id + '/duplicate', { ids: data.ids }, { emulateJSON: true })
  }
  return postData('forms/' + id + '/duplicate')
}

export function archive(id, data = {}) {
  if (data.ids && data.ids.length > 1) {
    return deleteData('forms/' + id + '/archive', { ids: data.ids })
  }
  return deleteData('forms/' + id + '/archive')
}

export function resetFormStatus(id) {
  return deleteData('forms/' + id + '/resetstatus')
}

export function share(data) {
  return postData('forms/' + data.form_id + '/share', data)
}

export function getFormLists(data) {
  return getData('forms/list?listParams=' + encodeURIComponent(JSON.stringify(data)))
}

export function getFormTrackingEvents(formId) {
  return getData('forms/' + formId + '/tracking-events')
}

export function updateFooterText(formId, data) {
  return putData('forms/' + formId + '/footerText', data, { emulateJSON: true })
}

export function restoreForm(id, data = {}) {
  if (data.ids && data.ids.length > 1) {
    return putData(`forms/${id}/restore`, { ids: data.ids })
  }
  return putData(`forms/${id}/restore`)
}

export function permanentDeleteForm(id, confirmed = false) {
  return deleteData(`forms/${id}/permanent-delete?confirmed=${confirmed}`)
}

export function getFormsByUserId({ user_id }) {
  const params = new URLSearchParams()
  params.append('user_id', user_id)
  return getData('forms/getFormsByUserId?' + params.toString())
}
